import { render, staticRenderFns } from "./HeaderGeneral.vue?vue&type=template&id=e06979d6&scoped=true&"
import script from "./HeaderGeneral.vue?vue&type=script&lang=js&"
export * from "./HeaderGeneral.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGeneral.vue?vue&type=style&index=0&id=e06979d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06979d6",
  null
  
)

export default component.exports